import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import styled from 'styled-components';
import './InterviewCreateEvent.css';
import Button from '../../../components/UI/Button/Button';
import Textbox from '../../../components/UI/Textbox/Textbox';
import Textarea from '../../../components/UI/Textarea/Textarea';
import Grid from '../../../components/UI/FormGrid/FormGrid';
import MediaQuery from 'react-responsive';
import Icon from '../../../components/UI/Icon/Icon';
import Dropdown from '../../../components/UI/DropDown/Dropdown';
import ConsoleLog from '../../../hoc/ConsoleLog/ConsoleLog';
import ToastNotification from '../../../components/UI/ToastNotification/ToastNotification';
import axios from '../../../services/axios-service';
import { checkValidity } from '../../../shared/utility';
import SelectionBox from '../../../components/UI/SelectionBox/SelectionBox';
import DateSelector from '../../../components/UI/DateSelector/DateSelector';
import {Durations, TimePeriod} from '../../../shared/constants';
import TimePicker from '../../../components/UI/TimePicker/TimePicker';
import AttachFile from '../../../hoc/AttachFile/AttachFile';
import config from '../../../config';
import {InterviewAccordion,InterviewAccordionItem } from '../../../components/Recruiter/InterviewAccordion';
import * as actions from '../../../store/actions/index';
import Modal from '../../../components/UI/Modal/Modal';
import AWS from 'aws-sdk';
import Loader from '../../../components/UI/Loader/Loader';

const TimePickerFormGroup = styled.span`
  position: relative;
  border: none;
  overflow: hidden;
`;

const TimePickerLabel = styled.label`
  font-size: 14px;
  font-weight: 500;
  color: #323c47;
  display:block;
`;

const TimePickerWrapper = styled.div`
  float: left;
  position: relative;
  width: 58px; 
  height:71px;
  @media(min-width: 768px) {    
    width: 88px; 
  }
`;

const TimePickerInput = styled.input`
  padding: 10px 4px;
  font-size: 12px;
  font-weight: 500;
  color: #323c47;
  width: 58px;
  height: 44px;
  border-radius: 4px;
  border: solid 1px #e9eff4;
  &::placeholder {
    font-size: 14px;
  }

  @media(min-width: 768px) {
    width: 88px;
    padding: 10px 15px;
    font-size: 14px;
  }
`;

const TimeWrapper = styled.div`
  position: relative;
  margin-bottom: 36px;  //to changes as 36px
  &:last-child {                  /* -----to be removed-----*/
    margin-bottom: 0px; 
  }
`;

const DatePicker = styled.div`
  display: inline-block;
`;

const FromTimeLabelWrapper = styled.div`
  display: inline-block;
  position: absolute;
  right: 160px;
  top: 40px;
  font-weight:500;
  @media(min-width:768px) {
    right: 272px;
  }
`;

const FromTimePickerWrapper = styled.div`
  display: inline-block;
  position: absolute;
  right: 95px;
  top: 0;
  @media(min-width:768px) {
    right: 174px;
  }
`;

const ToTimeLabelWrapper = styled.div`
  display: inline-block;
  position: absolute;
  right: 75px;
  top: 40px;
  @media(min-width:768px) {
    right: 148px;
  }
`;

const ToTimePickerWrapper = styled.div`
  display: inline-block;
  position: absolute;
  right: 10px;
  top: 0;
  @media(min-width:768px) {
    right: 50px;
  }
`;


class InterviewCreateEvent extends Component{
  constructor(props){
    super(props);
    this.state=this.getInitialState();
    this.interviewTitle = React.createRef();
  }

  getInitialState = () => {
    const today = moment(new Date()).format('YYYY-MM-DD') + " " + TimePeriod[0].value;
    const initialState = {
      interviewDetails:{
        interviewTitle:'',
        interviewType:'',
        interviewLocation:'',
        clientCompany:0,
        intervieweeDetails:[
          {
            fullName:'',
            email:'',
            bullhornId:'',
            duration:"30 mins",
            slots: [{slot:today}],      
          }
        ],
        interviewMessage:'',
        interviewAttachments:'',
      },
      isShowToast:false,
      toastMessage: null,
      toastVariant: null,
      toastId: null,
      createState:false,
      errorPosition:[],
      companyList:[],
      activeCompany:'',
      progressPercent:{},
      showDeleteModal:false,
      showInterviewDeleteModal:false,
      deleteInterviewLoader:false,
      intervieweeIndex:''
    };
    return initialState;
  }

  componentWillMount() {
    if(this.props.location.state) {
      //ConsoleLog("componentWillReceiveProps",this.props.location.state)
      if(this.props.location.state.interviewDetails) {
        const interviewDetails=this.props.location.state.interviewDetails;
        this.setState({interviewDetails,activeCompany:this.props.location.state.activeCompany});
      }
      else if(this.props.location.state.interviewId) {
        this.getInterviewDetails(this.props.location.state.interviewId).then((data) => {
          this.getCompanyList();
        })
      }  
    }
  }

  componentDidMount() {
    this.getCompanyList();
  }

  componentDidUpdate() {
    if(this.state.companyList.length === 0){
      this.getCompanyList();
    }
  }

  getCompanyList() {
    axios.get("/galaxy/interview-scheduler/client/list?userId="+this.props.recruiterDetails.user_id).then(response => {
      if (response.data.length > 0) {
        const companyList = response.data;
        const selectedCompany = this.state.interviewDetails.clientCompany !==0 && this.state.interviewDetails.clientCompany !== null ? companyList.find((company)=>company.companyId === this.state.interviewDetails.clientCompany):'';
        ConsoleLog("selectedCompany",selectedCompany)
        this.setState({ 
          companyList,
          activeCompany:selectedCompany
        });
      }
    })
    .catch((error) => {
        ConsoleLog('error', error);
    });
  }
  getInterviewDetails(interviewId) {
    axios.get("/galaxy/interview-scheduler/interview?interviewId="+interviewId)
    .then(response => {
      if (response.data) {
        const interviewDetails = response.data;
        interviewDetails.intervieweeDetails.map( interviewee => {
          interviewee.slots.map( slot => {
            slot.slot = slot.slot.substring(0, 19).replace("T", " ");
          });
        });
        //ConsoleLog("interviewDetails",interviewDetails)
        this.setState({ 
          interviewDetails
        });
      }
    })
    .catch((error) => {
        ConsoleLog('error', error);
    });
    return new Promise((resolve, reject)=> {
      resolve("data");
    });
  }

  handleCompanyChange =(e,item) => {
    e.preventDefault();
    const selectedCompany = this.state.companyList.find((company)=>company.companyId === item);

    if(selectedCompany !== this.state.activeCompany) {
      const interviewDetails={...this.state.interviewDetails};
      interviewDetails.clientCompany = selectedCompany.companyId;
      let newErrorPosition = [];
     
      newErrorPosition = this.state.errorPosition.filter((errPosition) => errPosition !== "clientCompany");
     
      this.setState({activeCompany:selectedCompany,interviewDetails,errorPosition:newErrorPosition});
    
    }
    this.autoSaveInterviewDetails();

  }

  handleInterviewDetailsChange=(event)=>{
    event.preventDefault();
    const interviewDetails={...this.state.interviewDetails};
    interviewDetails[event.target.id]=event.target.value;
    let newErrorPosition = [];
     
    newErrorPosition = this.state.errorPosition.filter((errPosition) => errPosition !== event.target.id);
    this.setState({interviewDetails,errorPosition:newErrorPosition});
    
  }
  handleInterviewDetailsOnBlur = (event) => {     
      this.autoSaveInterviewDetails();
    
   }

   handleIntervieweeDetailsBlur = (event,index) => {
    event.preventDefault();
    const name = event.target.id;
    const value = event.target.value;
    let errorPosition=[...this.state.errorPosition];
    if(name ==="email" && value.trim() !=="" && value.trim() !==null && !checkValidity(value,'isEmail')) {
      errorPosition.push("EmailFormat"+index);
      this.setState({errorPosition});
    }
    else {
      this.autoSaveInterviewDetails();
    }
   }


   handleIntervieweeDetailsChange = (event,index) => {
    event.preventDefault();
    const name = event.target.id;
    const interviewDetails={...this.state.interviewDetails};
    let newErrorPosition = [];
    let intervieweeDetails = [...interviewDetails.intervieweeDetails];
    intervieweeDetails[index][event.target.id] = event.target.value;
    interviewDetails.intervieweeDetails = intervieweeDetails;    
    if(name === "email") {
      newErrorPosition = this.state.errorPosition.filter((errPosition) => (errPosition !== "email"+index && errPosition !== "EmailFormat"+index));
    }
    else {
      newErrorPosition = this.state.errorPosition.filter((errPosition) => errPosition !== name+index);
    }
    this.setState({interviewDetails,errorPosition:newErrorPosition});

   }
  
   /**
   * @desc cloase toast notification
   * @param null
   * @return null
   */
  handleCloseToastNotification =()=>{
    this.setState({
      isShowToast: false,
      toastMessage: null,
      toastVariant: null,
      toastAutoClose: false
    })
  }

  handleKeyPressChange = (e,index) => {
    const intervieweeDetails = [...this.state.interviewDetails.intervieweeDetails];
    const variable=intervieweeDetails[index].id;
    var e = e || window.event; // for trans-browser compatibility
    var charCode = e.charCode || e.which || e.keyCode;                    
    if ((charCode > 31 && (charCode < 47 || charCode > 57))|| (variable && variable.length>15)){
      e.preventDefault();
    }
    
    if (e.shiftKey) {
      e.preventDefault();
    }  
  }
  handleDateChange = (date,index,intervieweeId,timeIndex) =>{
    //ConsoleLog("parent handle",date)
    const interviewDetails={...this.state.interviewDetails};    
    let intervieweeDetails = [...interviewDetails.intervieweeDetails];
    let newErrorPosition = [];
    let newSlots = [...intervieweeDetails[index].slots]
    const dateTime = newSlots[timeIndex].slot;
    intervieweeDetails[index].slots[timeIndex].slot = moment(date).format('YYYY-MM-DD') + " " + (dateTime.split(" ")[1] ? dateTime.split(" ")[1] : TimePeriod[0].value);
    interviewDetails.intervieweeDetails = intervieweeDetails; 
    newErrorPosition = this.state.errorPosition.filter((errPosition) => (errPosition !== "InvalidTime"+index+timeIndex));
    this.setState({interviewDetails,errorPosition:newErrorPosition});
    this.autoSaveInterviewDetails();
  }


  /**
   * @desc cloase toast notification
   * @param event,DurationId
   * @return null
   */

  handleDurationChange = (id,index,intervieweeId) => {
    const interviewDetails={...this.state.interviewDetails};
    let intervieweeDetails = [...interviewDetails.intervieweeDetails];
    intervieweeDetails[index].duration = Durations.find(duration=>duration.id ==id).label;
    interviewDetails.intervieweeDetails = intervieweeDetails;
    this.setState({interviewDetails});
    this.autoSaveInterviewDetails();
  }
  handleAddAlternateTime = (index,intervieweeId)=>{    
    const interviewDetails={...this.state.interviewDetails};
    const today = moment(new Date()).format('YYYY-MM-DD') + " " + TimePeriod[0].value;
    var intervieweeDetails = [...interviewDetails.intervieweeDetails];
    intervieweeDetails[index].fullName = intervieweeDetails[index].fullName?intervieweeDetails[index].fullName:' ';
    if(intervieweeDetails[index].slots.length < 3) {
      intervieweeDetails[index].slots.push({slot:today});
      this.setState({intervieweeDetails});
      this.autoSaveInterviewDetails('attach');
    }

  }
  autoSaveInterviewDetails=(attach,DontshowAutoSave)=>{
    const interviewDetails={...this.state.interviewDetails};
      interviewDetails.userId=this.props.recruiterDetails.user_id;
      interviewDetails.userName= this.props.recruiterDetails.user_fname + " " + this.props.recruiterDetails.user_lname;
      interviewDetails.interviewTitle= interviewDetails.interviewTitle?interviewDetails.interviewTitle:''
      //ConsoleLog("autoSave interviewdEtails",interviewDetails);    
    if(!this.state.createState && (interviewDetails)){  
      if(attach) {
        this.setState({createState:true});
      }
      else {
        !DontshowAutoSave?
       this.setState({
        createState:true,
        isShowToast: true,
        toastMessage: 'Auto saving..',
        toastVariant: 'info',
        toastAutoClose: false ,
        toastId: "tid" + (new Date()).getTime()
      }):""
      };
      axios.post("/galaxy/interview-scheduler/interview",JSON.stringify(interviewDetails)).then((response)=>{
        const interviewDetailsNew={...this.state.interviewDetails};
        interviewDetailsNew.interviewId =response.data.interviewId;
        if(response.data.intervieweeId) {
          const newIndex = interviewDetailsNew.intervieweeDetails.findIndex(interview=>!interview.id);
          // ConsoleLog("newIndex",this.state.interviewDetails.interviewId !== response.data.interviewId)
          interviewDetailsNew.intervieweeDetails[newIndex].id= response.data.intervieweeId;
          if(this.state.interviewDetails.interviewId !== response.data.interviewId){
            this.props.onSetInterViewListCount({count:this.props.interviewListCount.count+1});    /*this should be properly handled once the proper save or draft option came*/
          }
        };
        if(attach) {this.setState({createState:false,interviewDetails:interviewDetailsNew})}        
        else {
          !DontshowAutoSave?
          this.setState({
            interviewDetails:interviewDetailsNew,
            isShowToast: true,
            toastMessage: 'Auto saved',
            toastVariant: 'success',
            toastAutoClose: false ,
            toastId: "tid" + (new Date()).getTime() ,
            createState:false
          }):""
        }
      }).catch((error)=>{
        ConsoleLog(error);
        throw error;
      })

    }   
  }

   
  componentWillUnmount() {
    this.handleResetState();
  }

  handleResetState = () => {
    this.setState(this.getInitialState());
  }

  handleTimeSelect = (selectedTime, timeIndex, intervieweeIndex) => {
    const interviewDetails = {...this.state.interviewDetails}
    const intervieweeDetails = [...interviewDetails.intervieweeDetails];
    let newErrorPosition = [];
    const dateTimeArray = intervieweeDetails[intervieweeIndex].slots[timeIndex].slot.split(' ');
    dateTimeArray[0] = dateTimeArray[0] ? dateTimeArray[0]: moment(new Date()).format('YYYY-MM-DD');
    dateTimeArray[1] = selectedTime ? selectedTime : TimePeriod[0].value;
    const dateTime = dateTimeArray.join(' ');
    intervieweeDetails[intervieweeIndex].slots[timeIndex].slot = dateTime;
    interviewDetails.intervieweeDetails = intervieweeDetails;
    newErrorPosition = this.state.errorPosition.filter((errPosition) => (errPosition !== "InvalidTime"+intervieweeIndex+timeIndex));
    this.setState({ interviewDetails: interviewDetails,errorPosition:newErrorPosition});    
    this.autoSaveInterviewDetails();
  }

  handleToDate = (selectedDate, intervieweeIndex) => {    
   // ConsoleLog("handleToDate",selectedDate, intervieweeIndex)
    const selectedDateCheck= selectedDate.length == 9 ?moment(new Date()).format('YYYY-MM-DD') + " " + selectedDate: selectedDate;
    const intervieweeDetails = [...this.state.interviewDetails.intervieweeDetails];
    const duration = intervieweeDetails[intervieweeIndex].duration;
    let toDate = "";
    if(duration === "30 mins") {
      toDate = moment(selectedDateCheck).add(30, 'minutes').format('hh:mma');
    } else {
      const durationArray = duration.split(" ")
      toDate = moment(selectedDateCheck).add(durationArray[0], 'hours').format('hh:mma');
    }
    //ConsoleLog("todate",selectedDateCheck, intervieweeIndex,toDate)
    return toDate;
  }

  handleGetTime = (index,timeIndex) => {
    const intervieweeDetails = [...this.state.interviewDetails.intervieweeDetails];
    const prefferedDateTime = intervieweeDetails[index].slots[timeIndex].slot;
    const prefferedDateTimeArray = prefferedDateTime.split(" ");
    const prefferedTimeId = prefferedDateTimeArray[1];
    return prefferedTimeId;
  }
  handleAddInterviewee= (event)=>{
    event.preventDefault();
    const today = moment(new Date()).format('YYYY-MM-DD') + " " + TimePeriod[0].value;    
    let interviewDetails = {...this.state.interviewDetails};
    let intervieweeDetails = [...interviewDetails.intervieweeDetails];
    let intervieweeDetailsArray = intervieweeDetails.concat({
                                    fullName:'',
                                    email:'',
                                    bullhornId:'',
                                    duration:"30 mins",
                                    slots: [{slot:today}],  
                                  } );
   interviewDetails.intervieweeDetails = intervieweeDetailsArray;
    this.setState({ interviewDetails});
  }
  handleRemoveAtternativeTime = (interviewIndex,timeIndex) => {
    const intervieweeDetails = [...this.state.interviewDetails.intervieweeDetails];
    intervieweeDetails[interviewIndex].slots.splice(timeIndex, 1);
    this.setState({intervieweeDetails});
    this.autoSaveInterviewDetails();
  }

  deleteModal = (index)=>{
    this.setState({showDeleteModal:true,intervieweeIndex:index});
  }
  handleDeleteInterviewee = (index)=> {
    //ConsoleLog("index delete",index);
    // event.preventDefault();
    let interviewDetails ={...this.state.interviewDetails}
    let intervieweeDetails = [...interviewDetails.intervieweeDetails];
    intervieweeDetails.splice(index, 1);
    interviewDetails.intervieweeDetails = intervieweeDetails;
    this.setState({ 
      interviewDetails, 
      showDeleteModal:false,
      isShowToast:true,
      toastMessage: "Interviewee has been removed",
      toastVariant: "success",
      toastId: "tid" + (new Date()).getTime() ,
      intervieweeIndex:''
    });
    const DontshowAutoSave=true;
    this.autoSaveInterviewDetails(DontshowAutoSave);
  };
  handleCancelDeleteInterviewee=(event)=>{
    this.setState({showDeleteModal:false})
  }
  handleMessageChange = (e) => {
    e.preventDefault();
    const interviewDetails={...this.state.interviewDetails};
    interviewDetails.interviewMessage=e.target.value;
    this.setState({interviewDetails });
  }
   
  handleMessageOnBlur = (event) => {
    event.preventDefault();
    this.autoSaveInterviewDetails();
  }

  handleAttachClick = ()=> {
    if(!this.state.interviewDetails.interviewId) {
      const interviewDetails={...this.state.interviewDetails};
      interviewDetails.interviewTitle = interviewDetails.interviewTitle?interviewDetails.interviewTitle:' ';
      this.setState({interviewDetails});
      this.autoSaveInterviewDetails('attach');
    } 
  }
  addFile = (file)=> {
    let progressPercent = {...this.state.progressPercent};
    progressPercent[file.name] = 0;
    this.setState({progressPercent});
    this.uploadFile(file, this.state.interviewDetails.interviewId +  '/' + file.name)
    .then((data)=> {
      //ConsoleLog("datakey",data.Key)
      const interviewDetails={...this.state.interviewDetails};
      let interviewAttachments = interviewDetails.interviewAttachments;
      interviewAttachments = interviewDetails.interviewAttachments? interviewDetails.interviewAttachments + ';' + data.Key:data.Key;
      interviewDetails.interviewAttachments = interviewAttachments;
      this.setState({interviewDetails});
      this.autoSaveInterviewDetails();
    },
    (err) => { 
      ConsoleLog("error",err);
    });
  }

  handleRemoveFile = (file) => {
    //ConsoleLog("remove",file)
    const interviewDetails={...this.state.interviewDetails};
    var attachArray = interviewDetails.interviewAttachments.split(";").filter(item => !item.includes(file));
    //ConsoleLog("attachArray",attachArray);
    interviewDetails.interviewAttachments = attachArray.join(";");
    //ConsoleLog("newArray",interviewDetails.interviewAttachments);
    this.setState({interviewDetails });
    this.removeFile(this.state.interviewDetails.interviewId +  '/' + file)
      .then((data)=> {
        this.autoSaveInterviewDetails();
      },
      (err) => { 
        ConsoleLog("error",err);
      });
  }

  handleDiscardClick = () => {
    this.setState({showInterviewDeleteModal:true})
  }

  handleCancelDeleteInterview = () => {
    this.setState({showInterviewDeleteModal:false})
  }

  handleDeleteInterview = () => {
    this.setState({deleteInterviewLoader:true,showInterviewDeleteModal:false})
    if(this.state.interviewDetails.interviewId) {
      axios.delete('galaxy/interview-scheduler/interview?userId=' + 
      this.props.recruiterDetails.user_id + '&interviewId=' + this.state.interviewDetails.interviewId + 
      '&userName='+ this.props.recruiterDetails.user_fname + " " + this.props.recruiterDetails.user_lname)
      .then(response=> {
        if(response.data.message ==="success") {
          this.props.onSetInterViewListCount({count:this.props.interviewListCount.count-1});  /*this should be properly handled once the proper save or draft option came*/
          
          this.setState({deleteInterviewLoader:false});
          this.props.history.push({
            pathname:'/recruiter/interview-scheduler',
            state:{
              message:"Interview has been deleted"
              }
          });
        } 
      })
      .catch((error) => {
        ConsoleLog(error);
      throw error;
      });
    }
    else {
      this.props.history.push({
        pathname:'/recruiter/interview-scheduler',
        state:{
          message:"Interview has been deleted"
          }
      });
    }
  }

  uploadFile = (file, filePath) => {
    //ConsoleLog("file",file, file.name);
    AWS.config.update({
      region : config.cognito.region
    });
    
    let logins = {}
    logins['cognito-idp.'+ config.cognito.region +'.amazonaws.com/' + config.cognito.userPool] = this.props.user.storage['CognitoIdentityServiceProvider.'+ config.cognito.clientId +'.' + this.props.attributes.email + '.idToken'];
    // Add the User's Id Token to the Cognito credentials login map.
    AWS.config.credentials = new AWS.CognitoIdentityCredentials({
        IdentityPoolId: config.cognito.identityPool,
        Logins: logins
    });
          
    let S3 = new AWS.S3({ params: { Bucket: config.cognito.interviewBucketName }});
    // Specify the S3 upload parameters
    let params = {
      Key: filePath,
      ContentType: file.type,
      Body: file,
      // ACL: 'public-read'
    };

    return new Promise((resolve, reject)=> {
      S3.upload(params).on('httpUploadProgress',  (progress)=> {
        const progressPercentage = progress.loaded/progress.total * 100;
        let progressPercent = {...this.state.progressPercent};
        progressPercent[file.name] = progressPercentage;
        this.setState({progressPercent});
      }).send( (err, data)=> {
          if (err) {
            reject(err);
          } else {         
            resolve(data);
          }
      });
    });
  }
  removeFile= (filePath) => {
    //ConsoleLog("file",filePath);
    AWS.config.update({
      region : config.cognito.region
    });
    
    let logins = {}
    logins['cognito-idp.'+ config.cognito.region +'.amazonaws.com/' + config.cognito.userPool] = this.props.user.storage['CognitoIdentityServiceProvider.'+ config.cognito.clientId +'.' + this.props.attributes.email + '.idToken'];
    // Add the User's Id Token to the Cognito credentials login map.
    AWS.config.credentials = new AWS.CognitoIdentityCredentials({
        IdentityPoolId: config.cognito.identityPool,
        Logins: logins
    });
          
    let S3 = new AWS.S3({ params: { Bucket: config.cognito.interviewBucketName }});
    // Specify the S3 upload parameters
    let params = {
      Key: filePath
      // ACL: 'public-read'
    };

    return new Promise(function(resolve, reject) {
      S3.deleteObject(params, function(err, data) {
          if (err) {
              reject(err);
          } else {              
            resolve(data);
          }
      });
    });
  }
  saveDraft =(e)=>{        
    if(this.state.interviewDetails.interviewId ){
      this.autoSaveInterviewDetails();
      let path = `/recruiter/interview-scheduler`;
      this.props.history.push({
        pathname:path,
        state:{
          message:"Saved as Draft"
        }
      });      
    }
  }
  focusInput = (e) => {
    this.autoFocusField.focus();
  };
  handlePreview=(e)=>{ 
    const interviewDetails = {...this.state.interviewDetails};
    let errorPosition=[...this.state.errorPosition];
    const intervieweeDetails = [...interviewDetails.intervieweeDetails];
    let errorFlag = false;
    intervieweeDetails.map((intervieweeDetails,index)=> 
    intervieweeDetails.slots.filter((slot) =>(new Date(slot.slot) < new Date()))).map(arr=>
      {
        if(arr.length){
          errorFlag = true;
      }
    }
    )
    //ConsoleLog(errorFlag);

    if(interviewDetails.interviewTitle.trim() === "" ||
      interviewDetails.interviewType.trim() === "" ||
      interviewDetails.interviewLocation.trim() === "" || 
      interviewDetails.clientCompany === 0 ||
      intervieweeDetails.filter((intervieweeDetails,index) =>(intervieweeDetails.fullName.trim() === "" ||
        intervieweeDetails.email.trim() === "" ||
        intervieweeDetails.email.trim() !=="" && intervieweeDetails.email.trim() !==null && !checkValidity(intervieweeDetails.email,'isEmail') ||
        intervieweeDetails.bullhornId.trim() === "")).length>0
      || errorFlag)
      {      
        if( interviewDetails.interviewTitle.trim() ==="") {
          errorPosition.push("interviewTitle");
        }
        if(interviewDetails.interviewType.trim() ==="") {
          errorPosition.push("interviewType");
        }
        if(interviewDetails.interviewLocation.trim() ==="") {
          errorPosition.push("interviewLocation");
        }
        if(interviewDetails.clientCompany === 0 ){
          errorPosition.push("clientCompany");
        }
        intervieweeDetails.map((intervieweeDetails, index) => {
          const intervieweeIndex = index;
          if(intervieweeDetails.fullName.trim() === "" ||intervieweeDetails.email.trim() === "" || intervieweeDetails.bullhornId.trim() === "" ||
          intervieweeDetails.slots.filter((slot) =>(new Date(slot.slot) < new Date())).length>0) {
            if(intervieweeDetails.fullName.trim() ==="") {
              errorPosition.push("fullName"+intervieweeIndex);
            }

            if(intervieweeDetails.email.trim() ==="") {
              errorPosition.push("email"+intervieweeIndex);
            }
            if(intervieweeDetails.email.trim() !=="" && intervieweeDetails.email.trim() !==null && !checkValidity(intervieweeDetails.email,'isEmail')) {
              errorPosition.push("EmailFormat"+intervieweeIndex);
            }
            if(intervieweeDetails.bullhornId.trim() ==="") {
              errorPosition.push("bullhornId"+intervieweeIndex);            
            }
            intervieweeDetails.slots.map((slot,index)=> {
              if(new Date(slot.slot) < new Date()) {
                errorPosition.push("InvalidTime"+intervieweeIndex+index); 
              }
            })
          }
        }); 
        this.focusInput (e);
        ConsoleLog("errorPosition",errorPosition)
    this.setState({errorPosition });
    }else{
      this.props.history.push(
        {
          pathname: '/recruiter/interview-scheduler/preview',
          state: {
            interviewDetails: this.state.interviewDetails,
            activeCompany: this.state.activeCompany,
            userId:this.props.recruiterDetails.user_id,
            userName: this.props.recruiterDetails.user_fname + " " + this.props.recruiterDetails.user_lname
          }
        } 
      
      ) 
    }
 
  }
  render() {    
      const companyList = this.state.companyList.map((company)=> {
      return {value :company.companyId, name: company.companyName};
    });

    var fileTypes = ["application/vnd.openxmlformats-officedocument.wordprocessingml.document","application/msword","image/jpeg", "image/jpg", "image/png", "image/gif", "application/pdf", "application/vnd.ms-powerpoint", "application/vnd.openxmlformats-officedocument.presentationml.presentation"];
    return(            
      <div className="create-event-container">
         { this.state.deleteInterviewLoader ? <Loader className="delete-interview-loader"/> : null }
        <div className="create-event-header">
          {/* Desktop View Section starts */}	
            <MediaQuery query="(min-device-width: 769px)">
            <div className="recruiter-interview-back" onClick={()=>{this.props.history.push('/recruiter/interview-scheduler');
              if(this.state.interviewDetails.interviewId){
                this.autoSaveInterviewDetails(true)
              }
              }}>
              <Icon icon="left-arrow" className ="recruiter-interview-back-icon "/>
              <span className="create-event-back">Back</span>
            </div>
            </MediaQuery>
          {/* Desktop View Section Ends */}
          <h1>CREATE INTERVIEW </h1>
        </div>
        <div className="interview-event-card-item-first">
        <Grid grid="auto auto">
          <Textbox 
            id="interviewTitle" 
            inputRef={input => (this.autoFocusField = input)}
            className={(this.state.errorPosition.includes("interviewTitle")) ?"invalid-input":""}
            label="Event Title" 
            placeholder="Enter Event Title" 
            value={this.state.interviewDetails.interviewTitle} 
            onChange={(event) => this.handleInterviewDetailsChange(event)}
            onBlur={(event)=> this.handleInterviewDetailsOnBlur(event)}
            >
            <p className="error-message">{(this.state.errorPosition.includes("interviewTitle")) ? "Please enter an Event Title " : null}</p>          
          </Textbox>
          <Textbox 
            id="interviewType" 
            className={(this.state.errorPosition.includes("interviewType")) ? "invalid-input" :"" }
            label="Type of Interview" 
            placeholder="Enter Type of Event" 
            value={this.state.interviewDetails.interviewType} 
            onChange={(event) => this.handleInterviewDetailsChange(event)}
            onBlur={(event)=> this.handleInterviewDetailsOnBlur(event)}
            > 
            <p className="error-message">
            {(this.state.errorPosition.includes("interviewType")) ? "Please enter the Type of Interview ":null}</p>
          </Textbox>
          <Textbox 
            id="interviewLocation" 
            className={(this.state.errorPosition.includes("interviewLocation")) ? "invalid-input" :"" }
            label="Location of Interview" 
            placeholder="Enter the Location" 
            value={this.state.interviewDetails.interviewLocation} 
            onChange={(event) => this.handleInterviewDetailsChange(event)}
            onBlur={(event)=> this.handleInterviewDetailsOnBlur(event)}
            > 
            <p className="error-message">
            {(this.state.errorPosition.includes("interviewLocation")) ? "Please enter the Location" :null}</p>
          </Textbox>
          <div className={(this.state.errorPosition.includes("clientCompany")) ? "interview-scheduler-dropdown error" :"interview-scheduler-dropdown"}>
            <label>Client Company</label>
            <span className="form-error-message">
                <p className="error-message">
                  {(this.state.errorPosition.includes("clientCompany")) 
                    ? "Please select Client  " 
                    :null}
                </p>
              </span>
              <Dropdown 
                className="interview-scheduler-client-dropdown" 
                activeItem={this.state.activeCompany.companyName} 
                list={companyList}
                activeId={this.state.activeCompany.companyId}
                handleItemChange={this.handleCompanyChange}
                placeholder="Please Select Company"
              />
          </div>
        </Grid>
        </div>
        {this.state.interviewDetails.intervieweeDetails.map((interviewee,index)=> {
          const interviewIndex = index;
          return (
          <div className="interviewees-container">
            <InterviewAccordion isAccordion={true} defaultActiveKey={interviewIndex} >
              <InterviewAccordionItem 
              accordionKey={interviewIndex} 
              index={interviewIndex}
              title={interviewIndex>0?"INTERVIEWEE DETAILS ("+(interviewIndex+1)+")":"INTERVIEWEE DETAILS"}
              addInterviewee={this.handleAddInterviewee}
              deleteModal={()=>this.deleteModal(interviewIndex)}
            >
          <div className="interview-details-content">                 
            <Fragment>
              <div className="card-item-second-inputs">
                <div className="card-item-second-send-to">Send to :</div>
                <Grid>
                  <Textbox 
                    id="fullName" 
                    label="Candidate Name"
                    className={(this.state.errorPosition.includes("fullName"+interviewIndex)) ?"invalid-input":""}
                    placeholder="Enter Candidate Name" 
                    value={interviewee.fullName}
                    onChange={(event) => this.handleIntervieweeDetailsChange(event,interviewIndex,interviewee.id)}
                    onBlur={(event) => this.handleIntervieweeDetailsBlur(event,interviewIndex)}
                  >
                  <p className="error-message">{(this.state.errorPosition.includes("fullName"+interviewIndex)) ? "Please enter the Candidate name" : null}</p>  
                  </Textbox>        
                  <Textbox 
                    id="email" 
                    label="Candidate Email"
                    className={((this.state.errorPosition.includes("email"+interviewIndex)) || (this.state.errorPosition.includes("EmailFormat"+interviewIndex))) ?"invalid-input":""}
                    placeholder="Enter Candidate Email" 
                    value={interviewee.email}
                    onChange={(event) => this.handleIntervieweeDetailsChange(event,interviewIndex,interviewee.id)}
                    onBlur={(event) => this.handleIntervieweeDetailsBlur(event,interviewIndex)}
                  >
                  <p className="error-message">{(this.state.errorPosition.includes("email"+interviewIndex)) ? "Please enter the Candidate email" : (this.state.errorPosition.includes("EmailFormat"+interviewIndex))?"Please enter a valid Email" :null}</p>  
                  </Textbox>        
                  <Textbox 
                    id="bullhornId" 
                    label="Bullhorn ID"
                    className={(this.state.errorPosition.includes("bullhornId"+interviewIndex)) ?"invalid-input":""}
                    placeholder="Enter Bullhorn ID" 
                    value={interviewee.bullhornId}
                    onChange={(event) => this.handleIntervieweeDetailsChange(event,interviewIndex,interviewee.id)}
                    onBlur={(event) => this.handleIntervieweeDetailsBlur(event,interviewIndex)}
                    onKeyPress={(event)=>this.handleKeyPressChange(event,interviewIndex)}
                  >
                  <p className="error-message">{(this.state.errorPosition.includes("bullhornId"+interviewIndex)) ? "Please enter the Candidate Bullhorn ID" : null}</p>  
                  </Textbox>        
                </Grid>
              </div>
              <div className="card-item-second-date-time">
                <div className="card-item-second-date-time-title">Date & Time :</div>
                <label>Duration</label>
                <SelectionBox 
                  data={Durations}
                  activeElementId ={Durations.find(duration=>duration.label ===interviewee.duration).id}
                  handleSelect={(id)=>this.handleDurationChange(id,interviewIndex,interviewee.id)}
                  mobileMarginRight={'20px'}
                  marginBottom={'32px'}
                />
                {this.state.interviewDetails.intervieweeDetails[interviewIndex].slots.map((dateTime,index)=> {
                  const timeIndex = index;
                  return(
                    <Fragment key={timeIndex}>
                      {timeIndex=== 0?<label>Preferred Time</label>:''}
                      {(this.state.errorPosition.includes("InvalidTime"+interviewIndex+timeIndex)) ?<span className="error-message">Please enter a valid Date/Time</span> : null}                   
                      <TimeWrapper>
                        <DatePicker>
                          <DateSelector 
                            format="dd mmm yyyy" 
                            handleSelect = {(dateTime)=>this.handleDateChange(dateTime,interviewIndex,interviewee.id,timeIndex)} 
                            date={new Date(dateTime.slot.replace(/\-/g, '/'))}
                          /> 
                        </DatePicker>
                        <FromTimeLabelWrapper>
                          <label className="time-label">From</label>  
                        </FromTimeLabelWrapper>
                        <FromTimePickerWrapper>
                          <TimePicker 
                            leftPosition={'-252px'} 
                            selectedTime={this.handleGetTime(interviewIndex,timeIndex)}
                            handleSelect={(time)=>this.handleTimeSelect(time, timeIndex, interviewIndex)} 
                          />
                        </FromTimePickerWrapper>
                        <ToTimeLabelWrapper>
                          <label className="time-label">To</label> 
                        </ToTimeLabelWrapper>
                        {timeIndex !== 0?<Icon icon="Attach-close" className="alternate-time-remove" onClick={()=>this.handleRemoveAtternativeTime(interviewIndex,timeIndex)}/>:''}
                        <ToTimePickerWrapper>
                          <TimePickerFormGroup>
                            <TimePickerLabel>{'Time'}</TimePickerLabel>
                            <TimePickerWrapper>
                              <TimePickerInput
                                type="text"
                                value={this.handleToDate(this.state.interviewDetails.intervieweeDetails[interviewIndex].slots[timeIndex].slot,interviewIndex)}
                                readOnly="readonly"
                              />
                            </TimePickerWrapper>
                          </TimePickerFormGroup>
                        </ToTimePickerWrapper>
                      </TimeWrapper>
                      {timeIndex===0?
                        <Fragment>
                          <label >Alternative Time</label>
                          
                          {this.state.interviewDetails.intervieweeDetails[interviewIndex].slots.length<3?
                          <span className="alternative-time-add-section">
                            <Icon icon="add-more-icon" onClick={()=>this.handleAddAlternateTime(interviewIndex,interviewee.id)}/>
                          </span>:''}
                        </Fragment>
                      :''}
                    </Fragment>
                  )
                })}
                </div>                
            </Fragment>                       
          </div>
        {/* </div>  */}
        </InterviewAccordionItem >
      </InterviewAccordion>
       </div>
      )})}
        <div className="interview-event-card-item-third">
          <div className="interview-details-header"><h1>MESSAGE</h1></div>
              <div className="interview-details-message">
                <Textarea
                  name="textarea-message" 
                  placeholder="Please enter a message for your candidate."
                  value={this.state.interviewDetails.interviewMessage}
                  onChange={(event)=>this.handleMessageChange(event)}
                  onBlur={this.handleMessageOnBlur}>
                </Textarea>
                <AttachFile 
                  multiple={true}
                  buttonText="+ ATTACH"
                  maxSize ={1024*1024}
                  acceptedTypes = ".doc,.docx,.jpg,.jpeg,.png,.gif,.pdf,.ppt,.pptx"
                  DragAcceptedTypes = {fileTypes}
                  handleFileSelect={this.addFile}
                  handleFileRemove={this.handleRemoveFile}
                  onclickAttach = {this.handleAttachClick}
                  progressPercent={this.state.progressPercent}
                  selectedFiles = {this.state.interviewDetails.interviewAttachments}
                  />
                  <div className="interview-buttons">     
                  <Button className="interview-preview-buttons" onClick={()=>{this.handlePreview();this.autoSaveInterviewDetails(true)}} buttonicon="preview-icon">PREVIEW & SEND</Button>
                  <Button 
                  className="interview-draft-buttons"
                  disabled= {this.state.interviewDetails.interviewId?false:true}
                  onClick={()=>{this.saveDraft();this.autoSaveInterviewDetails()}}
                  buttonicon="draft-icon"
                  > 
                  SAVE DRAFT
                  </Button> 
                  <Button className="interview-discard-buttons" onClick={this.handleDiscardClick} buttonicon="discard-icon">DISCARD</Button>
                  </div>

              </div>
        </div> 
        {this.state.isShowToast?
        <ToastNotification 
          isShowToast={this.state.isShowToast} 
          message={this.state.toastMessage} 
          variant={this.state.toastVariant} 
          autoClose={this.state.toastAutoClose}
          onClose={this.handleCloseToastNotification}
          toastId= {this.state.toastId} 
        />:""}
        <Modal className="interviewee-delete-modal" show={this.state.showDeleteModal===true}>
          <p>Are you sure you want to delete ?</p>
          <div className="delete-interviewee-buttons">
            <Button className="interviewee-delete-cancel" onClick={this.handleCancelDeleteInterviewee}>Cancel</Button>
            <Button className="interviewee-delete-confirm" onClick={()=>this.handleDeleteInterviewee(this.state.intervieweeIndex)}>Yes, Delete</Button>
          </div>
        </Modal>
        <Modal className="interview-delete-modal" show={this.state.showInterviewDeleteModal===true}>
          <p>Are you sure you want to delete the Interview?</p>
          <div className="delete-interview-buttons">
            <Button className="interview-delete-cancel" onClick={this.handleCancelDeleteInterview}>Cancel</Button>
            <Button className="interview-delete-confirm" onClick={this.handleDeleteInterview}>Yes, Delete</Button>
          </div>
        </Modal>
      </div>                  
    ) 
    
  }
}
/**
* @desc connecting to redux store
* @param state
* @return redux state
*/
const mapStateToProps = state => ({
  recruiterDetails: state.clientProfile.clientDetails,
  user: state.cognito.user,
  attributes: state.cognito.attributes, 
  interviewListCount: state.clientProfile.interviewListCount  
}); 

/**
* @desc connecting to redux actions
* @param dispatch
* @return redux actions
*/
const mapDispatchToProps = dispatch => {
  return {
    onSetInterViewListCount:(count) => dispatch(actions.setInterViewListCount(count)),
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(InterviewCreateEvent);



// WEBPACK FOOTER //
// ./src/container/Recruiter/InterviewCreateEvent/InterviewCreateEvent.js